import { type RolePermissions, type UserRole } from "@prisma/client";

export const resolveManagerRolePermissions = ({
  rolePermissions,
  role,
}: {
  rolePermissions: RolePermissions[];
  role: UserRole | "MANAGER";
}) => {
  const managerRolePermissions = rolePermissions.find((rolePermission) => rolePermission.role === "MANAGER");
  const userRolePermissions = rolePermissions.find((rolePermission) => rolePermission.role === role);

  const canAccessMarketData = managerRolePermissions?.canAccessMarketData || userRolePermissions?.canAccessMarketData;
  const canAccessSalaryBands =
    managerRolePermissions?.canAccessSalaryBands || userRolePermissions?.canAccessSalaryBands;
  const canAccessCompensationReview =
    managerRolePermissions?.canAccessCompensationReview || userRolePermissions?.canAccessCompensationReview;

  const canAccessPeopleDashboard =
    managerRolePermissions?.canAccessPeopleDashboard || userRolePermissions?.canAccessPeopleDashboard;

  const canAccessPeopleDashboardMarketData =
    managerRolePermissions?.canAccessPeopleDashboardMarketData ||
    userRolePermissions?.canAccessPeopleDashboardMarketData;

  const canAccessPeopleDashboardSalaryBands =
    managerRolePermissions?.canAccessPeopleDashboardSalaryBands ||
    userRolePermissions?.canAccessPeopleDashboardSalaryBands;

  return {
    canAccessMarketData,
    canAccessSalaryBands,
    canAccessCompensationReview,
    canAccessPeopleDashboard,
    canAccessPeopleDashboardMarketData,
    canAccessPeopleDashboardSalaryBands,
  };
};
